import { render } from "./Index.vue?vue&type=template&id=2b733806"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./Index.vue?vue&type=style&index=1&id=2b733806&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__